import cadviewer from "cadviewer";

// State variables for drag selection
let generic_canvas_flag_first_click_rectangle = false;
let generic_canvas_flag_rectangle = false;
let cvjs_RubberBand: any;
let cvjs_firstX = 0;
let cvjs_firstY = 0;
let cvjs_lastX = 0;
let cvjs_lastY = 0;

/**
 * Start drag method for selecting space objects
 */
export const select_drag_rect_start = function (x: number, y: number, evt: object) {
  generic_canvas_flag_first_click_rectangle = true;
  generic_canvas_flag_rectangle = false;

  // 12.7.1  12.7.2
  cvjs_firstX = cadviewer.cvjs_SVG_x(x);
  cvjs_firstY = cadviewer.cvjs_SVG_y(y);
  cvjs_lastX = cvjs_firstX;
  cvjs_lastY = cvjs_firstY;


  const tPath_r = "M" + 0 + "," + 0;
  cvjs_RubberBand = cadviewer
    .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
    .attr({
      fill: "#ff9999",
      "fill-opacity": "0.5",
      stroke: "#ff9999",
      "stroke-opacity": "1",
    });

  console.log("select_drag_rect_start :"+" Drag selection started at: " + cvjs_firstX + ", " + cvjs_firstY);
};

/**
 * Move drag method for selecting space objects
 */
export const select_drag_rect_move = function (dx: number, dy: number, x: number, y: number) {
  try {
    if (generic_canvas_flag_first_click_rectangle) {
      cadviewer.cvjs_customCanvasMethod_globalScale();
      if (!generic_canvas_flag_rectangle) {
        cvjs_firstX = cadviewer.cvjs_SVG_x(x);
        cvjs_firstY = cadviewer.cvjs_SVG_y(y);
        cvjs_lastX = cvjs_firstX;
        cvjs_lastY = cvjs_firstY;
        generic_canvas_flag_rectangle = true;
      } else {
        // we cannot have the mouse directly on top of the rubberband path, then it will not respond
        const mousedelta = 1;
        cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
        cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
      }

      let tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
      tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
      tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
      tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
      tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
      cvjs_RubberBand.attr({ path: tPath_r });
    }
  } catch (err) {
    console.log(err);
  }
};






/**
 * Stop drag method for selecting space objects - highlights selected spaces as MULTISELECT
 */
export const select_drag_rect_stop_highlight = function () {
  cvjs_RubberBand.attr({ path: "M0,0" });
  let mybox;
  let overlap;
  let selected_list = "";

  // reorder x, if not dragged left to right, top to bottom
  let temp;
  if (cvjs_firstX > cvjs_lastX) {
    temp = cvjs_firstX;
    cvjs_firstX = cvjs_lastX;
    cvjs_lastX = temp;
  }
  // reorder y, if not dragged left to right, top to bottom
  if (cvjs_firstY > cvjs_lastY) {
    temp = cvjs_firstY;
    cvjs_firstY = cvjs_lastY;
    cvjs_lastY = temp;
  }

  const selectedList: string[] = [];

  // get all spaces
  const spaceObjectIds = cadviewer.cvjs_getSpaceObjectIdList();
  // loop over all spaces
  for (const spc in spaceObjectIds) {
    // get the bounding box of the space
    mybox = cadviewer.cvjs_getSpaceObjectBoundingBox(spaceObjectIds[spc]);
    // check if it overlaps with the drag rectangle
    if (mybox === false) continue;

    overlap = cadviewer.cvjs_rect_doOverlap(
      cvjs_firstX,
      cvjs_firstY,
      cvjs_lastX,
      cvjs_lastY,
      mybox.x,
      mybox.y,
      mybox.x + mybox.width,
      mybox.y + mybox.height
    );

    if (overlap) {
      selected_list += spaceObjectIds[spc] + ";";
      selectedList.push(spaceObjectIds[spc]);
    }
  }

  if (selected_list === "") selected_list = "None";


  var highlight_red = {
    fill: "#fa8072",
    "fill-opacity": 0.8,
    stroke: "#8B0000", // #8B0000   #fa8072    // red
    "stroke-width": 2.0, //
    "stroke-opacity": 1,
    "stroke-linejoin": "round",
  };

  /*
    for (let i = 0; i < selectedList.length; i++) {
      cadviewer.cvjs_highlightSpace(selectedList[i], highlight_red);
    }
  */
  // update with Multiselect list
  cadviewer.cvjs_updateMultiSelectArray(selectedList);

  cadviewer.cvjs_removeCustomCanvasMethod();
  console.log("select_drag_rect_stop_highlight: Selected Objects: " + selected_list, cvjs_firstX, cvjs_firstY, cvjs_lastX, cvjs_lastY);





  // Dispatch event with selected spaces for other components to use
  window.dispatchEvent(new CustomEvent('spacesSelected', {
    detail: { selectedSpaces: selectedList }
  }));
};
